import { ChevronRight } from "lucide-react";
import {
  UnstyledButton,
  Text,
  Group,
  Avatar,
  createStyles,
} from "@mantine/core";
import React, { forwardRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AuthProfile from "../../features/auth/services/model/AuthProfile";

interface UserCardProps extends React.ComponentPropsWithoutRef<"button"> {
  displayText: boolean;
  auth: AuthProfile;
  onNavigate?: () => void;
}

const useStyles = createStyles((theme) => ({
  user: {
    display: "block",
    width: "100%",
    padding: `${theme.spacing.xs}px ${theme.spacing.sm}px`,
    borderRadius: theme.radius.sm,
    color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
    "&:hover": {
      backgroundColor:
        theme.colorScheme === "dark" ? theme.colors.dark[8] : "var(--pink-100)",
    },
  },
  userActive: {
    "&&": {
      backgroundColor: "var(--pink-100)",
    },
  },
}));

// eslint-disable-next-line react/display-name
const UserCard = forwardRef<HTMLButtonElement, UserCardProps>(
  ({ displayText, auth, onNavigate, ...others }: UserCardProps, ref) => {
    const { classes, cx } = useStyles();

    const navigate = useNavigate();
    const location = useLocation();
    const isActive = location.pathname.startsWith("/settings");

    return (
      <UnstyledButton
        ref={ref}
        type="button"
        className={cx(classes.user, { [classes.userActive]: isActive })}
        {...others}
        onClick={() => {
          navigate("/settings");
          onNavigate?.();
        }}
      >
        <Group position="apart">
          {!displayText ? (
            <Avatar radius="xl" />
          ) : (
            <>
              <div style={{ flex: 1, width: "100%" }}>
                <Text
                  size="sm"
                  weight={500}
                  style={{
                    flexGrow: 0,
                    fontFamily: "Inter",
                    fontWeight: "normal",
                    fontStretch: "normal",
                    fontStyle: "normal",
                    lineHeight: "18px",
                    letterSpacing: "normal",
                    textAlign: "left",
                    color: "var(--grey-grey-80)",
                  }}
                >
                  {`${auth.first_name} ${auth.last_name}`}
                </Text>

                <Text
                  color="dimmed"
                  size="xs"
                  style={{
                    flexGrow: 0,
                    fontFamily: "Inter",
                    fontSize: "12px",
                    fontWeight: "normal",
                    fontStretch: "normal",
                    fontStyle: "normal",
                    lineHeight: 1.55,
                    letterSpacing: "normal",
                    textAlign: "left",
                    marginTop: "8px",
                  }}
                >
                  {auth.employer.company_name}
                </Text>
              </div>
              <ChevronRight size={14} />
            </>
          )}
        </Group>
      </UnstyledButton>
    );
  }
);
export default UserCard;
